<template>
  <v-container fluid class="px-5">
    <v-row v-if="!isLoadingContent">
      <v-col cols="12">
        <v-btn text @click="goBack()" >
          <v-icon small color="red" >mdi-arrow-left</v-icon>
          <label class="mx-2 px-2 text--disabled" style="letter-spacing: 0.6px;">Voltar</label>
        </v-btn>
      </v-col>

      <v-col v-if="hasMenu" cols="12" class="px-5">
        <v-card elevation="2">
          <v-card-text>
            <v-row class="px-5">
              <v-col cols="12" class="py-0 my-0">
                <span v-if="notificationConfig.selectedUsers.length == usersWithAccessPermission.length">Todos os usuários com permissão receberão notificação.</span>
                <span v-else-if="notificationConfig.selectedUsers.length == 0">Nenhum usuário foi selecionado.</span>
                <span v-else>Um total de {{ notificationConfig.selectedUsers.length }} {{ notificationConfig.selectedUsers.length == 1 ? 'usuário receberá': 'usuários receberão'}} notificações.</span>
              </v-col>

              <v-col cols="12" md="6">
                <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
                  <v-tab href="#tab-peoples">Pessoas</v-tab>
                  <v-tab href="#tab-perfils">Perfis</v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                  <v-tab-item :value="'tab-peoples'">
                    <v-list max-height="300" class="overflow-y-auto">
                      <v-subheader>Selecione os usuários</v-subheader>

                      <v-list-item-group v-model="notificationConfig.selectedUsers" multiple active-class="">

                        <v-list-item v-for="(users, index) in usersWithAccessPermission" :key="index">
                          <template v-slot:default="{ active }">
                            <v-list-item-action>
                              <v-checkbox :input-value="active"></v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <v-list-item-title>{{ users.email }}</v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </v-list-item>

                      </v-list-item-group>
                    </v-list>

                    <v-row v-if="usersWithAccessPermission && usersWithAccessPermission.length > 0">
                      <v-col>
                        <v-checkbox v-model="isCheckedAllUsers" dense label="Selecionar todos os usuários" @change="selectAllUsers()"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <v-tab-item :value="'tab-perfils'">
                    <v-list max-height="300" class="px-2 overflow-y-auto">
                      <v-subheader>Selecione os perfis</v-subheader>

                      <v-list-item-group v-model="notificationConfig.selectedProfiles" multiple active-class="">

                        <v-list-item v-for="(profile, index) in profiles" :key="index">
                          <template v-slot:default="{ active }">
                            <v-list-item-action>
                              <v-checkbox :input-value="active"></v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <v-list-item-title>{{ profile.name }}</v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </v-list-item>

                      </v-list-item-group>
                    </v-list>

                    <v-row v-if="profiles && profiles.length > 0">
                      <v-col>
                        <v-checkbox v-model="isCheckedAllProfiles" dense label="Selecionar todos os perfis" @change="selectAllProfiles()"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>

              <v-col cols="12" md="6">
                <v-row>
                  <v-col cols="12">
                    <v-text-field label="Descrição da Configuração" v-model="notificationConfig.title"
                                  maxlength="255" autofocus></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6" class="pb-0 mb-0">
                    <header class="py-0 my-0">Template Padrão</header>
                    <v-select :no-data-text="noDataAvailable" placeholder="Selecione um template" :items="driveDefaultTemplates"
                      item-text="description" item-value="id" v-model="notificationConfig.driveDefaultTemplateId"></v-select>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0 mb-0">
                    <header class="py-0 my-0">Template de E-mail</header>
                    <v-select :no-data-text="noDataAvailable" placeholder="Selecione um template" :items="driveEmailTemplates"
                              item-text="description" item-value="id" v-model="notificationConfig.driveEmailTemplateId"></v-select>
                  </v-col>

                  <v-col cols="12" sm="4" class="pb-0 mb-0">
                    <header class="py-0 my-0">Notificar ao Inserir</header>
                    <v-switch v-model="notificationConfig.insertable"></v-switch>
                  </v-col>
                  <v-col cols="12" sm="4" class="pb-0 mb-0">
                    <header class="py-0 my-0">Notificar ao Alterar</header>
                    <v-switch v-model="notificationConfig.updatable"></v-switch>
                  </v-col>
                  <v-col cols="12" sm="4" class="pb-0 mb-0">
                    <header class="py-0 my-0">Notificar ao Deletar</header>
                    <v-switch v-model="notificationConfig.deletable"></v-switch>
                  </v-col>

                  <v-col cols="12" class="pb-0 mb-0">
                    <header class="py-0 my-0">Tipos de Notificações</header>
                    <v-select :no-data-text="noDataAvailable" v-model="notificationConfig.deliveryChannels" :items="deliveryChannels"
                              attach chips placeholder="Selecione os tipos de notificações" multiple></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="mr-2" color="primary" @click="goBack()">
              Cancelar
            </v-btn>
            <v-btn text color="primary" @click="configureNotification()">
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col v-else>
        <v-card elevation="2">
          <v-card-text>
            <v-row class="px-5">
              <v-col cols="12" md="6">
                <v-row>
                  <v-col cols="12">
                    <v-text-field label="E-mails dos Usuários" v-model="notificationConfig.customEmails" autofocus></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field label="Descrição da Configuração" v-model="notificationConfig.title"
                                  maxlength="255"></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="4" class="pb-0 mb-0">
                    <header class="py-0 my-0">Notificar ao Inserir</header>
                    <v-switch v-model="notificationConfig.insertable"></v-switch>
                  </v-col>
                  <v-col cols="12" sm="4" class="pb-0 mb-0">
                    <header class="py-0 my-0">Notificar ao Alterar</header>
                    <v-switch v-model="notificationConfig.updatable"></v-switch>
                  </v-col>
                  <v-col cols="12" sm="4" class="pb-0 mb-0">
                    <header class="py-0 my-0">Notificar ao Deletar</header>
                    <v-switch v-model="notificationConfig.deletable"></v-switch>
                  </v-col>

                </v-row>
              </v-col>

              <v-col cols="12" md="6">
                <v-row>
                  <v-col cols="12" class="pb-0 mb-0">
                    <header class="py-0 my-0">Tipos de Notificações</header>
                    <v-select :no-data-text="noDataAvailable" v-model="notificationConfig.deliveryChannels" :items="deliveryChannelsSalesforce"
                              attach chips placeholder="Selecione os tipos de notificações" multiple></v-select>
                  </v-col>

                  <v-col cols="12" class="pb-0 mb-0">
                    <header class="py-0 my-0">Template Padrão</header>
                    <v-select :no-data-text="noDataAvailable" placeholder="Selecione um template" :items="driveDefaultTemplates"
                              item-text="description" item-value="id" v-model="notificationConfig.driveDefaultTemplateId"></v-select>
                  </v-col>

                  <v-col cols="12" class="pb-0 mb-0">
                    <header class="py-0 my-0">Template de E-mail</header>
                    <v-select :no-data-text="noDataAvailable" placeholder="Selecione um template" :items="driveEmailTemplates"
                              item-text="description" item-value="id" v-model="notificationConfig.driveEmailTemplateId"></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="mr-2" color="primary" @click="goBack()">
              Cancelar
            </v-btn>
            <v-btn text color="primary" @click="configureNotification()">
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="!isLoadingContent">
      <flash-message ></flash-message>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-overlay :value="isLoadingContent" :opacity="0">
          <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
        </v-overlay>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  saveNotificationConfig, findNotificationConfigById, updateNotificationConfig,
  getAllUsersWithAccessPermissionByFinancialGroup,
} from '@/common/driveserver';
import store from '@/common/store';

import { findAllDriveDefaultTemplates, findAllDriveEmailTemplates, findAllProfilesByAppCode } from '@/common/securityserver';

export default {
  name: 'ConfigureNotification',
  data: () => ({
    driveDefaultTemplates: [],
    driveEmailTemplates: [],
    indexesHistory: [],
    isCheckedAllProfiles: false,
    isCheckedAllUsers: true,
    isLoadingContent: false,
    itemParams: null,
    hasMenu: false,
    notificationConfig: {
      actualVersion: null,
      customEmails: '',
      deliveryChannels: null,
      driveDefaultTemplateId: null,
      driveEmailTemplateId: null,
      isSalesforceConfig: false,
      insertable: true,
      updatable: true,
      deletable: true,
      title: '',
      userIds: null,
      profileIds: null,
      selectedProfiles: [],
      selectedUsers: [],
      pathFileDir: null,
      parentId: null,
    },
    profiles: [],
    deliveryChannels: [
      { text: 'Notificação Padrão', value: 'DEFAULT_NOTIFICATION' },
      { text: 'Notificação via E-mail', value: 'EMAIL_NOTIFICATION' },
      { text: 'Notificação Push', value: 'PUSH_NOTIFICATION' },
    ],
    deliveryChannelsSalesforce: [
      { text: 'Notificação Padrão', value: 'DEFAULT_NOTIFICATION' },
      { text: 'Notificação via E-mail', value: 'EMAIL_NOTIFICATION' },
    ],
    usersWithAccessPermission: [],
    tab: '',
    noDataAvailable: 'Nenhum dado encontrado',
  }),
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'show-notification', params: { item: this.itemParams, indexesHistoryProps: this.indexesHistory }, query: { token: this.$route.query.token } });
    },
    enableAllUsersToNotification() {
      const usersLength = this.usersWithAccessPermission.length;
      for (let count = 0; count < usersLength; count += 1) {
        this.notificationConfig.selectedUsers.push(count);
      }
    },
    async configureNotification() {
      if (this.isEmptyField()) {
        return;
      }

      if (this.id === 0) {
        await this.createNotificationConfig();
      } else {
        await this.updateNotificationConfig();
      }
    },
    loadUserIdsSelectedsToSave() {
      const usersFiltered = [];
      this.notificationConfig.selectedUsers.forEach((value) => {
        usersFiltered.push(this.usersWithAccessPermission[value].userId);
      });
      this.notificationConfig.selectedUsers = usersFiltered;
    },
    loadProfileIdsSelectedsToSave() {
      const profilesFiltered = [];
      this.notificationConfig.selectedProfiles.forEach((value) => {
        profilesFiltered.push(this.profiles[value].id);
      });
      this.notificationConfig.selectedProfiles = profilesFiltered;
    },
    loadUserIdsSelecteds() {
      const userIdsSaveds = this.notificationConfig.userIds.split(',');

      userIdsSaveds.forEach((value) => {
        this.usersWithAccessPermission.forEach((user, index) => {
          if (user.userId === parseInt(value, 10)) {
            this.notificationConfig.selectedUsers.push(index);
          }
        });
      });
    },
    loadProfileIdsSelecteds() {
      const userIdsSaveds = this.notificationConfig.profileIds.split(',');

      userIdsSaveds.forEach((value) => {
        this.profiles.forEach((profile, index) => {
          if (profile.id === parseInt(value, 10)) {
            this.notificationConfig.selectedProfiles.push(index);
          }
        });
      });
    },
    async createNotificationConfig() {
      this.isLoadingContent = true;
      this.loadUserIdsSelectedsToSave();
      this.loadProfileIdsSelectedsToSave();

      await saveNotificationConfig(this.notificationConfig)
        .then(() => {
          this.goBack();
        })
        .catch(() => {
          this.flash('Não foi possível cadastrar a configuração de notificação.', 'error', { timeout: 5000 });
        });
    },
    async updateNotificationConfig() {
      this.isLoadingContent = true;
      this.loadUserIdsSelectedsToSave();
      this.loadProfileIdsSelectedsToSave();

      await updateNotificationConfig(this.notificationConfig, this.id)
        .then(() => {
          this.goBack();
        })
        .catch(() => {
          this.flash('Não foi possível alterar a configuração de notificação.', 'error', { timeout: 5000 });
        });
    },
    isEmptyField() {
      const emptyFields = [];
      if (this.notificationConfig.title.trim().length === 0) {
        emptyFields.push('Titulo');
      }
      if (this.hasMenu && this.notificationConfig.driveDefaultTemplateId === null) {
        emptyFields.push('Template Padrão');
      }
      if (this.notificationConfig.driveEmailTemplateId === null) {
        emptyFields.push('Template de E-mail');
      }
      if (this.hasMenu && (!this.notificationConfig.selectedUsers || (this.notificationConfig.selectedUsers && this.notificationConfig.selectedUsers.length === 0
        && (!this.notificationConfig.selectedProfiles || (this.notificationConfig.selectedProfiles && this.notificationConfig.selectedProfiles.length === 0))))) {
        emptyFields.push('Usuários');
      }
      if (!this.hasMenu && this.notificationConfig.customEmails.trim().length === 0) {
        emptyFields.push('E-mails dos Usuários');
      }
      if (!this.notificationConfig.deliveryChannels || (this.notificationConfig.deliveryChannels && this.notificationConfig.deliveryChannels.length === 0)) {
        emptyFields.push('Tipos de Notificações');
      }
      if (!this.notificationConfig.pathFileDir || this.notificationConfig.pathFileDir.trim().length === 0) {
        emptyFields.push('Path do Arquivo/Diretório');
      }

      if (emptyFields.length > 0) {
        this.flash(`Preencha os campos corretamente: ${emptyFields}.`, 'error', { timeout: 5000 });
        return true;
      }
      return false;
    },
    async loadDriveDefaultTemplates() {
      await findAllDriveDefaultTemplates(store.getToken())
        .then((response) => {
          if (response.data && response.data.length > 0) {
            this.driveDefaultTemplates = response.data;
          }
        })
        .catch(() => {
          this.flash('Ocorreu um erro ao carregar os templates default do drive.', 'error', { timeout: 5000 });
        });
    },
    async loadDriveEmailTemplates() {
      await findAllDriveEmailTemplates(store.getToken())
        .then((response) => {
          if (response.data && response.data.length > 0) {
            this.driveEmailTemplates = response.data;
          }
        })
        .catch(() => {
          this.flash('Ocorreu um erro ao carregar os templates email do drive.', 'error', { timeout: 5000 });
        });
    },
    async loadAllProfiles() {
      await findAllProfilesByAppCode(store.getToken())
        .then((response) => {
          if (response.data && response.data.length) {
            this.profiles = response.data;
          }
        })
        .catch(() => {
          this.flash('Ocorreu um erro ao carregar os perfis de usuário.', 'error', { timeout: 5000 });
        });
    },
    async findNotificationConfigById(id) {
      await findNotificationConfigById(id)
        .then((response) => {
          if (response.data) {
            this.notificationConfig.title = response.data.title;
            this.notificationConfig.insertable = response.data.insertable;
            this.notificationConfig.updatable = response.data.updatable;
            this.notificationConfig.deletable = response.data.deletable;
            this.notificationConfig.driveEmailTemplateId = response.data.driveEmailTemplateId;
            this.notificationConfig.driveDefaultTemplateId = response.data.driveDefaultTemplateId;
            this.notificationConfig.userIds = response.data.userIds;
            this.notificationConfig.profileIds = response.data.profileIds;
            this.notificationConfig.deliveryChannels = response.data.deliveryChannel ? response.data.deliveryChannel.split(',') : [];
            this.notificationConfig.pathFileDir = response.data.pathFileDir;
            this.notificationConfig.actualVersion = response.data.actualVersion;
            this.notificationConfig.parentId = response.data.parentId;
            this.notificationConfig.customEmails = response.data.customEmails;
            this.notificationConfig.isSalesforceConfig = response.data.isSalesforceConfig;

            this.loadUserIdsSelecteds();
            this.loadProfileIdsSelecteds();
          }
        })
        .catch(() => {
          this.flash('Ocorreu um erro ao carregar a configuração da notificação.', 'error', { timeout: 5000 });
        });
    },
    async loadUsersWithAccessPermissionByFinancialGroup() {
      const path = this.itemParams && this.itemParams.path ? this.itemParams.path : '';

      await getAllUsersWithAccessPermissionByFinancialGroup(path, store.getToken())
        .then((response) => {
          if (response.data && response.data.length > 0) {
            this.usersWithAccessPermission = response.data;
          }
        })
        .catch(() => {
          this.flash('Ocorreu um erro ao carregar os usuários a serem notificados.', 'error', { timeout: 5000 });
        });
    },
    loadRouteParams() {
      if (this.$route.params && this.$route.params.indexesHistoryProps) {
        this.indexesHistory = this.$route.params.indexesHistoryProps;
      }

      if (this.$route.params && this.$route.params.item) {
        this.itemParams = this.$route.params.item;
        this.notificationConfig.pathFileDir = this.itemParams.path;
      }
    },
    selectAllProfiles() {
      if (this.isCheckedAllProfiles) {
        this.notificationConfig.selectedProfiles = [];
        this.notificationConfig.selectedProfiles = Array.from(Array(this.profiles.length).keys());
      } else {
        this.notificationConfig.selectedProfiles = [];
      }
    },
    selectAllUsers() {
      if (this.isCheckedAllUsers) {
        this.notificationConfig.selectedUsers = [];
        this.notificationConfig.selectedUsers = Array.from(Array(this.usersWithAccessPermission.length).keys());
      } else {
        this.notificationConfig.selectedUsers = [];
      }
    },
  },
  async created() {
    this.isLoadingContent = true;
    this.hasMenu = store.getHasMenu();
    this.loadRouteParams();

    await this.loadDriveDefaultTemplates();
    await this.loadDriveEmailTemplates();

    if (this.hasMenu) {
      await this.loadAllProfiles();
      await this.loadUsersWithAccessPermissionByFinancialGroup();
    }

    if (this.id > 0) {
      this.isCheckedAllUsers = false;
      await this.findNotificationConfigById(this.id);
    } else if (this.hasMenu) {
      this.enableAllUsersToNotification();
    }

    if (this.id > 0) {
      // teste
    } else {
      this.notificationConfig.isSalesforceConfig = !this.hasMenu;
    }

    this.isLoadingContent = false;
  },
};
</script>

<style scoped>

</style>
